import React, { useEffect, useState } from 'react';
import LoginInput from '../components/inputs/LoginInput';
import { useNavigate, useLocation } from "react-router-dom";
import '../App.scss';
import { emailValidation, passwordValidation } from '../functions/Validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelopeCircleCheck } from "@fortawesome/pro-light-svg-icons";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

export default function RegisterForm(props: any) {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    props.setCurrentPage(0);
    props.setSidebarVisibility(false);
    const navigate = useNavigate();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') as string) : null;
    const [registerSuccess, setRegisterSuccess] = useState(false);
    const [validationFail, setValidationFail] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        userData && navigate('/YourAccount')
    }, [navigate])

    const register = async (e: React.FormEvent) => {
        setLoading(true);
        e.preventDefault();
        setError(null);

        let validationFailed = validateForm();

        setValidationFail(validationFailed);

        if (!validationFailed) {
            try {
                fetch(`${apiBaseUrl}Admin/Register`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "clientId": "",
                        "firstName": firstName,
                        "lastName": lastName,
                        "email": email,
                        "password": password,
                        "confirmPassword": confirmPassword
                    }),
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.success) {
                            setRegisterSuccess(true);
                        } else {
                            setError(result.message || 'An Error occurred. Please try again');
                            setLoading(false);
                        }
                    });
            } catch (err) {
                setError('An error occurred. Please try again later.');
                setLoading(false);
            }
        }
        else {
            setLoading(false);
        }
    };

    const validateForm = () => {
        if (!firstName || !lastName || !emailValidation(email) || !passwordValidation(password) || confirmPassword !== password) {
            return true;
        }
        return false;
    }

    const updateField = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        switch (name) {
            case 'firstName': setFirstName(value);
                break;
            case 'lastName': setLastName(value);
                break;
            case 'email': setEmail(value);
                break;
            case 'password': setPassword(value);
                break;
            case 'confirmPassword': setConfirmPassword(value);
                break;
        }
    };

    return (
        <div className="login-form-wrapper">
            {!registerSuccess &&
                <>
                    <form className="login-form" onSubmit={register}>
                        <p className="notification-title">Register</p>
                        <LoginInput
                            label="First Name"
                            name="firstName"
                            type="text"
                            placeholder="Enter your first name"
                            validate={(value: string) => (value ? null : 'First name required')}
                            onChange={updateField}
                            submitError={validationFail && !firstName ? 'First name required' : null}
                            disabled={loading}
                        />
                        <LoginInput
                            label="Last Name"
                            name="lastName"
                            type="text"
                            placeholder="Enter your last name"
                            validate={(value: string) => (value ? null : 'Last name required')}
                            onChange={updateField}
                            submitError={validationFail && !lastName ? 'Last name required' : null}
                            disabled={loading}
                        />
                        <LoginInput
                            label="Email"
                            name="email"
                            type="email"
                            placeholder="Enter your email address"
                            validate={(value: string) => (emailValidation(value) ? null : 'Please enter a valid email')}
                            onChange={updateField}
                            submitError={validationFail && !emailValidation(email) ? 'Please enter a valid email' : null}
                            disabled={loading}
                        />
                        <LoginInput
                            label="Password"
                            name="password"
                            type="password"
                            placeholder="Enter your new password"
                            validate={(value: string) => (passwordValidation(value) ? null : 'Password must be at least 6 characters.')}
                            onChange={updateField}
                            submitError={validationFail && !passwordValidation(password) ? 'Password must be at least 6 characters.' : null}
                            disabled={loading}
                        />
                        <LoginInput
                            label="Confirm Password"
                            name="confirmPassword"
                            type="password"
                            placeholder="Confirm your new password"
                            validate={(value: string) => !value ? 'Please confirm your password' : value !== password ? 'Passwords do not match' : null}
                            onChange={updateField}
                            submitError={validationFail && !confirmPassword ? 'Please confirm your password' : validationFail && confirmPassword !== password ? 'Passwords do not match' : null}
                            disabled={loading}
                        />
                        <br />
                        <div className="btn-container">
                            <button className="btn back" onClick={() => navigate('/Login')}>Back: Login</button>
                            {loading && <button disabled className="btn loading" type="submit">Registering <FontAwesomeIcon icon={faSpinner} spinPulse /></button> ||
                                <button className="btn primary" type="submit">Register</button>}
                        </div>
                        {error && <p className="error-message"> {error}</p>}
                    </form>
                </>
            }
            {registerSuccess &&
                <div className="formConfirmation">
                    <FontAwesomeIcon className="alert-icon" icon={faEnvelopeCircleCheck} />
                    <p>Please check your email for the verification action.<br />Click <span onClick={() => navigate('/Login')}>Login</span> if confirmed</p>
                </div>
            }
        </div>
    );
};

